export default "__VITE_ASSET__f2f43abc__"